import './App.scss';
import Home from './pages/Home';
import {Routes, Route, useLocation} from 'react-router-dom';
import About from './pages/About';
import Services from './pages/Services';
import Contactus from './pages/Contact/Contactus';
import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import SEO from './components/SEO/SEO';

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={
          <>
            <SEO 
              title="Dr Mishqah Dollie - Leading Dentist in Ottery, Cape Town | Professional Dental Care"
              description="Dr Mishqah Dollie provides comprehensive dental care in Ottery, Cape Town. From routine check-ups to emergency dental services, implants, and cosmetic dentistry. Book your appointment today!"
              keywords="dentist ottery cape town, dental clinic ottery, dr mishqah dollie, dental implants cape town, emergency dentist ottery, teeth whitening cape town, dental checkup ottery"
              canonical="https://drmishqahdollie.co.za"
            />
            <Home />
          </>
        } />
        <Route path="/about" element={
          <>
            <SEO 
              title="About Dr Mishqah Dollie - Experienced Dentist in Ottery, Cape Town"
              description="Meet Dr Mishqah Dollie, your trusted dentist in Ottery, Cape Town. Learn about our commitment to providing exceptional dental care with years of experience and modern technology."
              keywords="dr mishqah dollie about, dentist ottery experience, dental practice cape town, professional dentist ottery"
              canonical="https://drmishqahdollie.co.za/about"
            />
            <About />
          </>
        } />
        <Route path="/singleservice" element={
          <>
            <SEO 
              title="Dental Services in Ottery, Cape Town - Dr Mishqah Dollie"
              description="Comprehensive dental services in Ottery, Cape Town including implants, emergency care, teeth whitening, crowns, bridges, and more. Professional dental care by Dr Mishqah Dollie."
              keywords="dental services ottery, dental implants cape town, emergency dental care ottery, teeth whitening cape town, dental crowns ottery, dental bridges cape town"
              canonical="https://drmishqahdollie.co.za/singleservice"
            />
            <Services />
          </>
        } />
        <Route path="/contact" element={
          <>
            <SEO 
              title="Contact Dr Mishqah Dollie - Dental Practice in Ottery, Cape Town"
              description="Contact Dr Mishqah Dollie's dental practice in Ottery, Cape Town. Book appointments, get directions, or call for emergency dental care. Located at 280 Ottery Road."
              keywords="contact dentist ottery, dental appointment cape town, dr mishqah dollie contact, dental practice ottery address"
              canonical="https://drmishqahdollie.co.za/contact"
            />
            <Contactus />
          </>
        } />
      </Routes>
    </HelmetProvider>
  );
}

export default App;
